import styled from 'styled-components';
import Config from '@config';
import { rem } from 'polished';
import variables from '@styles/variables';

const PADDINGS = {
  mobileSmall: variables.size.containerPaddingMobileSmall,
  mobile: variables.size.containerPaddingMobile,
  fromTablet: variables.size.containerPaddingTablet,
  fromDesktop: variables.size.containerPaddingDesktop,
};

// On desktop, side panels (ex. menu and cart preview) push content inward.
// Padding for the panels is added to the total width.
const DESKTOP_PADDING_FOR_SIDE_PANELS = PADDINGS.fromDesktop * 2;

const WIDTHS = {
  /* Dynamic widths on mobile and tablet portrait */
  tabletLandscape: 940,
  desktop: 1032 + DESKTOP_PADDING_FOR_SIDE_PANELS,
  desktopLarge: 1224 + DESKTOP_PADDING_FOR_SIDE_PANELS,
  desktopXLarge: 1464 + DESKTOP_PADDING_FOR_SIDE_PANELS,
};

const StyledPageLayout = styled.div<{ $noMobilePadding?: boolean; $noLargeDesktop?: boolean }>`
  margin: 0 auto;
  max-width: 100%;

  /* MOBILE SMALL */
  width: 100%;
  padding: 0 ${({ $noMobilePadding }) => ($noMobilePadding ? 0 : `${rem(PADDINGS.mobileSmall)}`)};

  ${Config.MEDIA.FROM_MOBILE} {
    width: 100%;
    padding: 0 ${({ $noMobilePadding }) => ($noMobilePadding ? 0 : `${rem(PADDINGS.mobile)}`)};
  }

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    width: 100%;
    padding: 0 ${rem(PADDINGS.fromTablet)};
  }

  ${Config.MEDIA.FROM_TABLET_LANDSCAPE} {
    width: ${rem(WIDTHS.tabletLandscape)};
    // No padding used. The smaller breakpoint FROM_TABLET_PORTRAIT activates before
    // this breakpoint's width + tabletpadding reaches edge of screen
    padding: 0;
  }

  ${Config.MEDIA.FROM_DESKTOP} {
    width: ${rem(WIDTHS.desktop)};
    padding: 0 ${rem(PADDINGS.fromDesktop)};
  }

  ${Config.MEDIA.FROM_DESKTOP_LARGE} {
    width: ${({ $noLargeDesktop }) => ($noLargeDesktop ? rem(WIDTHS.desktop) : rem(WIDTHS.desktopLarge))};
    padding: 0 ${rem(PADDINGS.fromDesktop)};
  }

  ${Config.MEDIA.FROM_DESKTOP_XLARGE} {
    width: ${({ $noLargeDesktop }) => ($noLargeDesktop ? rem(WIDTHS.desktop) : rem(WIDTHS.desktopXLarge))};
    padding: 0 ${rem(PADDINGS.fromDesktop)};
  }
`;

export default StyledPageLayout;
